import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Media } from './model/media';
import { Img } from './model/img';
import { Article } from './model/article';
import { Menu } from './model/menu';
/* import { Img } from './data/img';
import { Media } from './data/media';
import { Article } from './data/article'; */

@Injectable()
export class EventSendeurService {
  childrens = {href: "gggg", typeTarget: "gggg",target:"ggggg",title:"ggg",name:"ggg",id:0,childrens: []}
  public pageSendeur: BehaviorSubject<[9]> = new BehaviorSubject<any>([]);
  // public article: BehaviorSubject<[9]> = new BehaviorSubject<any>([]);
  public message: BehaviorSubject<[9]> = new BehaviorSubject<any>([]);
  public user: BehaviorSubject<[9]> = new BehaviorSubject<any>([]);
  public category: BehaviorSubject<[9]> = new BehaviorSubject<any>([]);
  public commentaire: BehaviorSubject<[9]> = new BehaviorSubject<any>([]);
  public menu: BehaviorSubject<Menu> = new BehaviorSubject<any>([]);
  // public menu: BehaviorSubject< {href: "gggg", typeTarget: "gggg",target:"ggggg",title:"ggg",name:"ggg",id:0,childrens: []}> = new BehaviorSubject<any>([]);
  public fichier: BehaviorSubject<Media> = new BehaviorSubject<Media>(new Media);
  public image: BehaviorSubject<Img> = new BehaviorSubject<Img>(new Img);
  public article: BehaviorSubject<Article> = new BehaviorSubject<Article>(null);
 
  public agendaDelete : BehaviorSubject<[1]> = new BehaviorSubject<any>([]);
  public carousel : BehaviorSubject<[1]> = new BehaviorSubject<any>([]);
  // currentFile = this.fichier.asObservable();
  // currentImage = this.image.asObservable();
  currentDeleteEvent =  this.agendaDelete.asObservable();
  pageEvent = this.pageSendeur.asObservable();
  messageCourant = this.message.asObservable();
  // articleEvent = this.article.asObservable();
  userEvent = this.user.asObservable();
  commentaireEvent = this.commentaire.asObservable();
  categoryEvent = this.category.asObservable();
  menuEvent = this.menu.asObservable();
  // articleSubscription =this.carousel.asObservable();
  constructor() { }

  sendPageEvent(data){
    this.pageSendeur.next(data);
  }

  /* sendFile(data){
    this.fichier.next(data);
    this.fichier.asObservable().subscribe(data => {

    })
  } */

  sendMessage(data){
    this.message.next(data);
  }

  sendCategoryEvent(data){
    this.category.next(data);
}
sendMenuEvent(data){
    this.menu.next(data);
}

  sendUserEvent(data){
    this.user.next(data);
}
  /* sendCommentaireEvent(data){
    this.commentaire.next(data);
  } */

 /*  sendArticleEvent(data){
    this.article.next(data);
  } */


  

 
}
